"use client";

import { useEffect, useState } from "react";
import { getSkillIndex } from "@/lib/api/abilities";
import type { SkillIndex } from "@/lib/abilities/slashResolver";

/**
 * The active skill index for the current user — the <ability>:<skill> pairs
 * available for slash-command resolution in the chat composer. Fetched from the
 * server (GET /api/abilities/skill-index); the old ability_files-path
 * derivation died with that table.
 */
export function useActiveSkillIndex(userId: string | null): SkillIndex {
  const [index, setIndex] = useState<SkillIndex>([]);

  useEffect(() => {
    if (!userId) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIndex([]);
      return;
    }
    let cancelled = false;
    getSkillIndex()
      .then((idx) => {
        if (!cancelled) setIndex(idx);
      })
      .catch((err) => {
        if (!cancelled) {
          console.error("[useActiveSkillIndex] failed:", err);
          setIndex([]);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [userId]);

  return index;
}
